import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <div className="w-16 h-16 border-2 border-border mx-auto mb-8 flex items-center justify-center text-muted-foreground">
        <XCircle className="w-8 h-8" />
      </div>
      <div className="eyebrow text-muted-foreground mb-2">No worries</div>
      <h1 className="font-heading text-3xl md:text-4xl font-light mb-4" data-testid="payment-cancel">Checkout cancelled.</h1>
      <p className="text-muted-foreground mb-8">You haven't been charged.</p>
      <div className="flex justify-center gap-3">
        <Link to="/pricing"><Button className="rounded-none bg-foreground text-background hover:bg-foreground/90">Back to pricing</Button></Link>
        <Link to="/dashboard"><Button variant="outline" className="rounded-none border-foreground">Dashboard</Button></Link>
      </div>
    </div>
  );
}
